import Vue from 'vue'
import vuex from 'vuex'
import user from './modules/user'
import { SERVER_CONFIG_UPDATE } from '@/store/mutations'
import { GET_SERVER_CONFIG } from '@/store/actions'
import moment from 'moment/moment'
import { isElectron } from '@/utils/env.js'
Vue.use(vuex)

const SERVER_CONFIG_UPDATE_TIME = 1000 * 60 * 60 * 3 // 三个小时

export default new vuex.Store({
	modules: {
		user
	},
	state: {
		job: {
			num: 0, // 正在进行任务个数
			isDot: false, // 任务列表展示
			isShowTip: false,
			action: '导入',
			export: [],
			import: []
		},
		serverConfig: {},
		isCollapse: false,
		spRouter: [],
		menu: JSON.parse(localStorage.getItem('vuex.menu')) || [],
		breadLevels: [],
		searchParams: {},
		activeMenu: '' // 菜单栏选中状态 1-1 || 2-1-1
	},
	mutations: {
		isImportTip(state) {
			state.job.isShowTip = !state.job.isShowTip
		},
		// 后端进度条（导入通用）
		setJobQueueImport(state, params) {
			const index = state.job.import.findIndex(item => item?.job_id == params.job_id)
			if (index == -1) {
				let newParams = {
					...params,
					created_at: moment(params.created_at).format('YYYY-MM-DD HH:mm:ss'),
					progress: 0,
					status: 'progress' // 任务状态
				}
				state.job.num += 1
				state.job.action = '导入'
				state.job.import.unshift(newParams)
			} else {
				let newParams = {
					...params,
					created_at: moment(params.created_at).format('YYYY-MM-DD HH:mm:ss'),
					status: params.status == 3 ? 'error' : params.progress == 100 ? 'completed' : 'progress'
				}
				if (newParams.status == 'completed' || newParams.status == 'error') {
					state.job.num -= 1
					window.localStorage.setItem(`job_${state.user.userInfo.id}`, JSON.stringify({ ...state.job }))
				}
				if (newParams.status == 'completed') {
					state.job.isShowTip = true
				}
				state.job.import.splice(index, 1, newParams)
			}
			window.localStorage.setItem(`job_${state.user.userInfo.id}`, JSON.stringify({ ...state.job }))
		},
		// 前端虚假进度条（XLS导出专用）
		setJobQueueExportXLS(state, params) {
			const index = state.job.export.findIndex(item => item?.job_id == params.job_id)
			if (index == -1) {
				let newParams = {
					...params,
					created_at: moment(params.created_at).format('YYYY-MM-DD HH:mm:ss'),
					progress: 0,
					status: 'progress', // 任务状态
					stop: false // 任务中止
				}
				state.job.num += 1
				state.job.action = '导出'
				state.job.export.unshift(newParams)
			} else {
				let newParams = {
					...params,
					created_at: moment(params.created_at).format('YYYY-MM-DD HH:mm:ss'),
					status: params.status == 3 ? 'error' : params.progress == 100 ? 'completed' : 'progress'
				}
				if (newParams.status == 'completed' || newParams.status == 'error') {
					state.job.num -= 1
					window.localStorage.setItem(`job_${state.user.userInfo.id}`, JSON.stringify({ ...state.job }))
				}
				state.job.export.splice(index, 1, newParams)
			}
			window.localStorage.setItem(`job_${state.user.userInfo.id}`, JSON.stringify({ ...state.job }))
		},
		// MDF 后端进度条（目前用于教材课件导出，可通用）
		async setJobQueueExport(state, params) {
			const index = state.job.export.findIndex(item => item?.job_id == params.job_id)
			if (index == -1) {
				let newParams = {
					...params,
					progress: 0,
					url: '',
					created_at: '',
					status: 'progress', // 任务状态
					stop: false // 任务中止
				}
				state.job.action = '导出'
				state.job.num += 1
				state.job.export.unshift(newParams)
			} else {
				let newParams = {
					...params,
					created_at: moment(params.created_at).format('YYYY-MM-DD HH:mm:ss'),
					status:
						params.progress == 100 && params.url && params.failedJobs == 0
							? 'completed'
							: (params.progress == 100 && !params.url) || params.failedJobs >= 1
								? 'error'
								: 'progress'
				}
				if (newParams.status == 'completed') {
					setTimeout(() => {
						state.job.num -= 1
						window.localStorage.setItem(`job_${state.user.userInfo.id}`, JSON.stringify({ ...state.job }))
						const a = document.createElement('a')
						a.setAttribute('href', newParams.url)
						if (isElectron == false) {
							a.setAttribute('target', '_blank')
						}
						try {
							a.setAttribute('download', newParams.name)
							a.click()
							document.body.removeChild(a)
						} catch(_) {
							console.log('~')
						}
					}, 250)
				}
				if (newParams.status == 'error') {
					state.job.num -= 1
				}
				state.job.export.splice(index, 1, newParams)
			}
			window.localStorage.setItem(`job_${state.user.userInfo.id}`, JSON.stringify({ ...state.job }))
		},
    // 清空所有记录
    clearSearchParams(state) {
      state.searchParams = {}
    },
		setSearchParams(state, { key, params }) {
			state.searchParams[key] = params
		},
		setTabSearchParams(state, { key, top, params }) {
			if (!state.searchParams[key]) {
				state.searchParams[key] = {}
			}
			state.searchParams[key][top] = params
			state.searchParams[key]['historyTop'] = top
		},
		isCollapseChange(state) {
			state.isCollapse = !state.isCollapse
		},
		persist(state) {
			let toSave = {
				user: {
					userInfo: state.user.userInfo,
					evaluation: state.user.evaluation,
					examList: state.user.examList
				},
				serverConfig: state.serverConfig
			}

			localStorage.setItem('vuex.saved', JSON.stringify(toSave))
		},

		restore(state) {
			let saved = localStorage.getItem('vuex.saved')
			let restoredState = null
			if (saved && (restoredState = JSON.parse(saved))) {
				state.user.userInfo = restoredState.user.userInfo
				state.user.evaluation = restoredState.user.evaluation
				state.user.examList = restoredState.user.examList
				state.serverConfig = restoredState.serverConfig ? restoredState.serverConfig : {}
			}
		},
		[SERVER_CONFIG_UPDATE]: (state, serverConfig) => {
			state.serverConfig = serverConfig
		}
	},
	actions: {
		async [GET_SERVER_CONFIG]({ state, commit }) {
			let serverConfig = {}
			const currentTime = Date.now()
			const saveTime = state.serverConfig?.fetch_time

			// 找不到时间或超时
			if (!saveTime || currentTime - saveTime > SERVER_CONFIG_UPDATE_TIME) {
				serverConfig = await Vue.prototype.$api.serverConfig.show()
				serverConfig.fetch_time = currentTime
				commit(SERVER_CONFIG_UPDATE, serverConfig)
				commit('persist')
			}
		}
	}
})
